// extracted by mini-css-extract-plugin
export default {"wrapper":"coachProfilePage_wrapper__Rhm5H","gridWrapper":"coachProfilePage_gridWrapper__CKI+T","title":"coachProfilePage_title__Q7gVX"};